"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadableStore = void 0;
var Store_1 = require("./Store");
var utilities_1 = require("../utilities");
var ioc_1 = require("../ioc");
var mobx_1 = require("mobx");
var LoadableStore = /** @class */ (function (_super) {
    __extends(LoadableStore, _super);
    function LoadableStore() {
        var _this = _super.call(this) || this;
        Object.defineProperty(_this, "loadingTimer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new utilities_1.LoadingTimer()
        });
        Object.defineProperty(_this, "runWithSuspense", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: mobx_1.flow(function (func) {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.loadingTimer.startLoading();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, func()];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _a.sent();
                            throw error_1;
                        case 4:
                            this.loadingTimer.finishLoading();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            })
        });
        mobx_1.makeObservable(_this, {
            isLoading: mobx_1.computed,
            stillLoading: mobx_1.computed,
        });
        return _this;
    }
    Object.defineProperty(LoadableStore, "reset", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var container = ioc_1.getCoreContainer();
            try {
                var currentInstance = container.getNamed(this, Store_1.DEFAULT_TARGET_NAME);
                // Stop the loading timer
                currentInstance.loadingTimer.finishLoading();
                _super.reset.call(this);
            }
            catch (_a) {
                // Nothing to do if the container doesn't have an instance
            }
        }
    });
    Object.defineProperty(LoadableStore.prototype, "isLoading", {
        // Convenience getters
        get: function () {
            return this.loadingTimer.isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoadableStore.prototype, "stillLoading", {
        get: function () {
            return this.loadingTimer.stillLoading;
        },
        enumerable: false,
        configurable: true
    });
    return LoadableStore;
}(Store_1.Store));
exports.LoadableStore = LoadableStore;
//# sourceMappingURL=LoadableStore.js.map